import React from 'react';

const TasksPage: React.FunctionComponent<any> = () => {
  return (
    <div>
      <h3>Tasks Page</h3>
    </div>
  );
};

export default TasksPage;
